import SystemAPI from '@/apis/business/common/system-api.js'

export default {
  namespaced: true,

  actions: {

    /**
     * Lấy thông tin License
     * @param {*} context
     * @param {*} param
     * @returns
     */
    getLicenseInfo (context, param) {
      return new Promise((resolve, reject) => {
        SystemAPI.getAsync(`license-info/${param.OrgID}`)
          .then((res) => {
            context.commit('setClassroom', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
